<div class="chat-not-found">
  <div class="chat-not-found__icon">
    <img [src]="'/svg/chat-not-found.svg' | assetVersion" width="28" height="28" alt="" />
  </div>
  <div class="chat-not-found__title">Chat not found</div>
  <p class="chat-not-found__desc">The requested chat either doesn't exist or you don't have permission to access it.</p>
  <button class="chat-not-found__btn" (click)="backToPolaris.emit()">
    <img [src]="'/svg/ai-star-white.svg' | assetVersion" width="14" height="14" alt="" />
    Back to POLARIS
  </button>
</div>
